<template>
  <div class="translatable-input-widget-placeholder">
    <div class="with-tab" v-if="tabLayout">
      <b-tabs v-model="activeLanguage" class="custom-tabs" content-class="bg-white pt-3 pb-3"
              v-if="tabLayout && translatableFields.length">

        <b-tab v-for="(locale) in availableLocales" :key="`language_tab_${locale.key}`"
               :title-link-class="hasErrors(errors, locale.key) ? 'has-error' : ''">
          <template v-slot:title>
            {{ locale.name }}
            <span v-if="hasErrors(errors, locale.key)" style="width: 20px;height: 20px" id="exclamation-icon">
                        <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
                      </span>
            <b-tooltip target="exclamation-icon"
                       :title="$t('You have validation errors')"/>
          </template>
          <div class="row" v-for="(field, index) in translatableFields" :key="`${field.key}_${locale.key}_${index}`">
            <dynamic-main-field-input-widget
              v-if="isMainField(field)"
              :key="`${field.key}_${locale.key}`"
              :disabled="shouldDisable(field.type)" :hint="hint"
              :model="model"
              :attribute="`${field.key}_${locale.key}`"
              :rules="getRulesByKey(field.key)"
              :field="field"
              :class="field.css_class ? field.css_class : inputClass"
              :locale="locale.key"
              @select="selectMainField"
            />
            <template v-else-if="!field.depends_on || model[`${field.depends_on}_${locale.key}`]">
              <slot v-bind:name="`pre_${field.key}_${locale.key}`">
              </slot>
              <input-widget :key="`${field.key}_${locale.key}`"
                            :disabled="shouldDisable(field.type)" :hint="hint" :model="model"
                            :attribute="`${field.key}_${locale.key}`"
                            :type="field.type" :rules="getRulesByKey(field.key)"
                            :char-counter="field.hasCharCounter()"
                            :tags="field.isAppendable()"
                            :multiple="field.isMultiple()"
                            :items="field.getChoices(locale.key)" display-field="${item.key}"
                            value-field="value"
                            :class="field.css_class ? field.css_class : (field.type !== 'checkbox'? inputClass : 'col-md-4')"
                            @input="onInputChange($event, locale.key, field)"
                            @select2Select="onSelectionChange($event, field, locale.key, true)"
                            @select2Clear="onSelectionClear($event, field, locale.key)"
                            @change="onChange($event,  locale.key, field)"
                            @select2Unselect="onUnselect($event, field, locale.key)"
                            @onCkeditorReady="$emit('onCkeditorReady')"
                            @blur="onBlur($event, field.type)"/>
            </template>
          </div>
        </b-tab>
      </b-tabs>
      <hr v-if="availableLocales.length > 1 && translatableFields.length > 0"/>
      <div class="row">
        <div v-for="field in notTranslatableFields"
             :class="field.css_class ? field.css_class : (field.type !== 'checkbox'? inputClass : 'col-md-4')"
             :key="field.label">
          <dynamic-main-field-input-widget
            v-if="isMainField(field)"
            :key="`${field.key}_${masterLanguage.key}`"
            :disabled="shouldDisable(field.type)" :hint="hint"
            :model="model"
            :attribute="`${field.key}_${masterLanguage.key}`"
            :rules="getRulesByKey(field.key)"
            :field="field"
            :locale="masterLanguage.key"
            @select="selectMainField"
          />
          <template v-else-if="!field.depends_on || model[`${field.depends_on}_${masterLanguage.key}`]">
            <slot v-bind:name="`pre_${field.key}_${masterLanguage.key}`"/>
            <input-widget :disabled="shouldDisable(field.type)" :hint="hint" :model="model"
                          :attribute="`${field.key}_${masterLanguage.key}`"
                          :char-counter="field.hasCharCounter()" :rules="getRulesByKey(field.key)"
                          :type="field.type" :tags="field.isAppendable()" :multiple="field.isMultiple()"
                          :items="field.getChoices(masterLanguage.key)" display-field="${item.key}"
                          value-field="value" @input="onInputChange($event, null, field)"
                          @change="onChange($event, null, field)"
                          @select2Select="onSelectionChange($event, field, masterLanguage.key)"
                          @select2Clear="onSelectionClear($event, field, masterLanguage.key)"
                          @select2Unselect="onUnselect($event, field, masterLanguage.key)"
                          @onCkeditorReady="$emit('onCkeditorReady')"
                          @blur="onBlur($event, field.type)"/>
          </template>
        </div>
      </div>
    </div>
    <div class="without-tab row" v-else>
      <div v-for="(field, index) in fields"
           :class="field.css_class ? field.css_class : (field.type !== 'checkbox'? inputClass : 'col-md-4')"
           :key="`${field.label}_${index}`">
        <template v-for="(object, locale) in model[field.key]">
          <dynamic-main-field-input-widget
            v-if="isMainField(field)"
            :key="`${field.key}_${locale}`"
            :disabled="shouldDisable(field.type)" :hint="hint"
            :model="model"
            :attribute="`${field.key}_${locale}`"
            :rules="getRulesByKey(field.key)"
            :field="field"
            :label="field.label"
            :locale="locale"
            @select="selectMainField"
          />
          <template v-else-if="!field.depends_on || model[`${field.depends_on}_${masterLanguage.key}`]">
            <slot v-bind:name="`pre_${field.key}_${locale}`"/>
            <input-widget :key="`${field.key}-${locale}`"
                          :disabled="shouldDisable(field.type)" :hint="hint" :model="model"
                          :rules="getRulesByKey(field.key)"
                          :attribute="`${field.key}_${locale}`"
                          :char-counter="field.hasCharCounter()"
                          :type="field.type" :tags="field.isAppendable()" :multiple="field.isMultiple()"
                          :items="field.getChoices(masterLanguage.key)" display-field="${item.key}"
                          value-field="value" @input="onInputChange($event, locale, field)"
                          @change="onChange($event, locale, field)"
                          @select2Select="onSelectionChange($event, field, locale)"
                          @select2Clear="onSelectionClear($event, field, locale)"
                          @onCkeditorReady="$emit('onCkeditorReady')"
                          @select2Unselect="onUnselect($event, field, locale)" @blur="onBlur($event, field.type)"/>
          </template>
        </template>

      </div>
    </div>
  </div>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import i18nHelper from "@/core/services/i18n.service";
  import BaseModel from "@/core/components/input-widget/BaseModel";
  import DynamicMainFieldInputWidget from "./DynamicMainFieldInputWidget.vue";
  import {canDivide, canMultiply} from "@/core/helpers";

  const {mapState: mapStateGlobal} = createNamespacedHelpers('global')

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "TranslatableInputWidget",
    components: {DynamicMainFieldInputWidget, InputWidget},
    props: {
      model: {
        type: BaseModel,
        required: true
      },
      attribute: {
        type: String,
      },
      type: {
        type: String,
        default: 'textarea'
      },
      hint: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      skipDisablingByType: {
        type: String,
        default: null
      },
      items: {
        type: Array,
      },
      inputClass: {
        type: String,
        default: 'col-md-12'
      },
      fields: {
        type: Array,
        default: () => []
      },
      errors: {
        type: Object,
        default: () => {
        }
      },
      rules: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        activeLanguage: null,
        masterLanguage: i18nHelper.getMasterLanguage(),
        availableMathOperations: [
          'multiplication',
          'division',
        ]
      }
    },
    computed: {
      ...mapStateGlobal(['locales']),
      tabLayout() {
        return this.availableLocales.length > 1
      },
      availableLocales() {
        let masterLang = i18nHelper.getMasterLanguage();
        let localeKeys = Object.keys(this.locales.available_locales)

        // Move master lang to beginning of array
        if (localeKeys.indexOf(masterLang.key)) {
          localeKeys.splice(localeKeys.indexOf(masterLang.key), 1);
          localeKeys.unshift(masterLang.key);
        }

        return localeKeys.map(lang => {
          return {
            key: lang,
            name: this.locales.available_locales[lang]
          }
        })
      },
      translatableFields() {
        return this.fields.filter(f => f.translatable)
      },
      notTranslatableFields() {
        return this.fields.filter(f => !f.translatable)
      },
    },
    methods: {
      shouldDisable(field_type) {
        if (!this.disabled) {
          return false
        }

        if (this.skipDisablingByType) {
          return field_type !== this.skipDisablingByType
        }

        return true
      },
      getRulesByKey(key) {
        if (this.rules && this.rules[key]) {
          return this.rules[key]
        }
        return null
      },
      hasErrors(errors, locale) {
        for (let i in errors) {
          if (errors[i].length > 0 && i.includes(`_${locale}`)) {
            return true;
          }
        }
        return false;
      },
      assignValueToLocales(val, field_key, type) {
        this.availableLocales.forEach(locale => {
          this.model[`${field_key}_${locale.key}`] = type === 'select2' ? val.value : (type === 'date' && val === '') ? null : val;
        })
      },
      updateSelectionsForLocales(field, value, localeKey) {
        const key = field.key;

        this.availableLocales.forEach(locale => {
          if (localeKey === locale.key) {
            this.model[`${key}_${locale.key}`] = value.value;
          } else {
            let currentSelection = this.model[`${key}_${locale.key}`];
            if (currentSelection && !field.isNewChoice(currentSelection)) {
              this.model[`${key}_${locale.key}`] = null;
            }
          }
        });
      },
      onInputChange(val, locale, field) {
        let type = field.type;
        if (!field.translatable) {
          this.assignValueToLocales(val, field.key, field.type);
        }
        val = type === 'date' && val === '' ? null : val;
        this.$emit('onInputChange', val, locale, field)
        this.mathCalculate(field, locale, val)
      },
      onChange(val, locale, field) {
        let type = field.type;
        if (type === 'checkbox') {
          this.onInputChange(val, locale, field);
        }
      },
      onSelectionChange(value, field, localeKey, translatable = false) {
        const key = field.key;

        if (field.isAppendable() && value.isNew) {
          field.addChoice(localeKey, value);
          if (translatable) {
            this.updateSelectionsForLocales(field, value, localeKey);
          } else {
            this.assignValueToLocales(value, key, field.type);
          }
          this.$emit('onNewValuedAddedToDropdown', true)
        } else if (field.isMultiple()) {
          if (!this.model[key][localeKey]) {
            this.model[key][localeKey] = [];
          }
          this.model[key][localeKey].push(value.id);
          this.model[`${key}_${localeKey}`] = [...this.model[key][localeKey]];
        } else {
          this.assignValueToLocales(value, key, field.type);
        }

        this.$emit('onInputChange', value, localeKey, field)
      },
      onSelectionClear(value, field, localeKey) {
        const key = field.key;

        if (field.isMultiple()) {
          this.model[key][localeKey] = [];
          this.model[`${key}_${localeKey}`] = [...this.model[key][localeKey]];
        } else {
          this.assignValueToLocales(value, key, field.type);
        }
      },
      onUnselect(value, field, localeKey) {
        if (field.isMultiple()) {
          const selection = this.model[field.key][localeKey];
          if (Array.isArray(selection)) {
            this.model[field.key][localeKey] = selection.filter(item => item !== value.id);
            this.model[`${field.key}_${localeKey}`] = [...this.model[field.key][localeKey]];
          }
        }
      },
      onBlur(val, type) {
        val = type === 'date' && val === '' ? null : val;
        this.$emit('blur', val);
      },
      selectMainField({item, field, locale}) {
        const data = item.data;
        this.fields.forEach(f => {
          if (field.depended_fields.indexOf(f.key) > -1) {
            if (f.translatable) {
              for (let i in this.availableLocales) {
                let l = this.availableLocales[i].key;
                if (data[l]) {
                  let val = data[l][f.key] ? data[l][f.key] : null;
                  if (f.type === 'checkbox' && !val) {
                    val = false;
                  } else if (f.type === 'ckeditor' && !val) {
                    val = '';
                  }
                  this.model[`${f.key}_${l}`] = val;
                }
              }
            } else {
              this.assignValueToLocales(data[this.masterLanguage.key][f.key], f.key, f.type);
            }
          } else if (field.key === f.key) {
            for (let i in this.availableLocales) {
              let l = this.availableLocales[i].key;
              if (l !== locale && data[l]) {
                let val = data[l][f.key] ? data[l][f.key] : null;
                if (f.type === 'checkbox' && !val) {
                  val = false;
                } else if (f.type === 'ckeditor' && !val) {
                  val = '';
                }
                this.model[`${f.key}_${l}`] = val;
              }
            }
          }
        });
      },
      isMainField(field) {
        if (field.isMainField) {
          return field.isMainField()
        }
        return field.field_class_name === 'MainField';
      },
      mathCalculate(field, locale, value) {
        if (field.type === 'number' && field.math_calculate && this.availableMathOperations.includes(field.math_calculate.operation)) {
          if (['multiplication', 'division'].includes(field.math_calculate.operation)) {
            locale = locale ? locale : this.masterLanguage.key
            let checkMethod = field.math_calculate.operation === 'division' ? canDivide : canMultiply;
            if (checkMethod(value, field.math_calculate.factor)) {
              let x;
              if (field.math_calculate.operation === 'division') {
                x = Number(value) / Number(field.math_calculate.factor);
              } else {
                x = Number(value) * Number(field.math_calculate.factor);
              }
              const isWhole = Math.abs(x - Math.round(x)) < 1e-9; // treat tiny floating errors as whole numbers
              this.model[`${field.math_calculate.field}_${locale}`] = isWhole ? Math.round(x) : Math.round(x * 100) / 100;
            } else {
              this.model[`${field.math_calculate.field}_${locale}`] = null
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-tabs {
    /deep/ .tab-content {
      padding-bottom: 0 !important;
    }
  }
</style>
